import * as React from 'react'
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form'
import { Label, Error, Hint } from '@progress/kendo-react-labels'
import { TextArea } from '@progress/kendo-react-inputs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FormTextArea = (fieldRenderProps: FieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, hint, disabled, optional, maxLength, showCounter, showModal, modalTitle, required, ...others } = fieldRenderProps

    const showValidationMessage = touched && validationMessage
    const showHint = !showValidationMessage && hint
    const hintId = showHint ? `${id}_hint` : ''
    const errorId = showValidationMessage ? `${id}_error` : ''

    return (
        <FieldWrapper>
            <Label editorId={id} editorValid={valid} optional={optional}>
                {required &&
                    <span className='text-danger'>*</span>
                }

                {label}
                {
                    showModal &&
                    <a title={modalTitle} onClick={showModal} style={{ cursor: 'pointer' }}>&nbsp;<FontAwesomeIcon icon={['fas', 'question-circle']} /></a>
                }
                {
                    showCounter && maxLength &&
                    <span>&nbsp; {maxLength - (fieldRenderProps.value ? fieldRenderProps.value.length : 0)}  characters remaining.</span>

                }
                {
                    showValidationMessage &&
                    <Error id={errorId}>{validationMessage}</Error>
                }
            </Label>
            <TextArea
                valid={valid}
                id={id}
                disabled={disabled}
                maxLength={maxLength}
                ariaDescribedBy={`${hintId} ${errorId}`}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
        </FieldWrapper >
    )
}

export default FormTextArea